

















































import Vue, { PropType } from 'vue';
import { GSnsButtonColor } from '@/components/GSnsButton.vue';

export type SNSLinks = {
  twitter?: string;
  instagram?: string;
  facebook?: string;
  pinterest?: string;
  youtube?: string;
};

export default Vue.extend({
  name: 'GSnsLinkBlock',
  // components: {
  //   GSnsButton,
  // },
  props: {
    sns: {
      type: Object as PropType<SNSLinks>,
      required: true,
    },
    color: {
      type: String as PropType<GSnsButtonColor>,
      default: 'black',
      required: false,
    },
    border: {
      type: Boolean as PropType<boolean>,
      default: true,
      required: false,
    },
    transparent: Boolean as PropType<boolean>,
  },
});
